<template>
    <v-container fluid class="py-0 px-1">
        <v-data-table
            :headers="headers"
            :items="ranking"
            class="elevation-1  py-3 px-3 text-center rounded-0"
            hide-default-footer
            disable-sort
            :mobile-breakpoint="0"
            :items-per-page="-1"
            dark
            style="background-color: #232323; cursor: pointer;"
        >
            <template v-slot:item.club="{ item }">
                <v-row align="center" justify="center" @click="$router.push({ name: 'Team', params: { id: item.id } })">
                    <v-col cols="3">
                        <v-avatar style="border-radius: 10px;" size="35" color="white">
                            <img
                                v-if="item.imageUrl"
                                :src="`${assetsUrl}/${item.imageUrl}`"
                            >
                            <v-icon v-else :style="$vuetify.breakpoint.mobile ? '' : 'font-size: 40px'" class="teal--text"> mdi-basketball-hoop </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col cols="9">
                        <span class="font-weight-bold">{{ item.name }}</span>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.gp="{ item }">
                <v-row align="center">
                    <v-col cols="12">
                        {{ (item.won + item.lost) }}
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.win_percentage="{ item }">
                <v-row align="center">
                    <v-col cols="12">
                        {{ `${(item.won + item.lost) > 0 ? (item.won / (item.won + item.lost) * 100).toFixed(1) : 0}%` }}
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.position="{ item }">
                <v-row align="center">
                    <v-col cols="12">
                        {{ ranking.indexOf(item) + 1 }}
                    </v-col>
                </v-row>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>

    export default {
        props: {
            ranking: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                headers: [
                    { text: 'Club', value: 'club', width: '200px', align: 'start' },
                    { text: 'Points', value: 'standing', width: '50px', align: 'center' },
                    { text: 'GP', value: 'gp', width: '50px', align: 'center' },
                    { text: 'Won', value: 'won', width: '50px', align: 'center' },
                    { text: 'Lost', value: 'lost', width: '50px', align: 'center' },
                    { text: 'Win(%)', value: 'win_percentage', width: '50px', align: 'center' },
                    { text: 'Pts+', value: 'pointsPlus', width: '50px', align: 'center' },
                    { text: 'Pts-', value: 'pointsMinus', width: '50px', align: 'center' },
                    { text: '+/-', value: 'pointsDiff', width: '50px', align: 'center' }
                ],
                assetsUrl: 'https://storage.googleapis.com',
                type: 'regular_season',
                selectedLeague: null
            }
        },
        watch: {
        },
        created() {
        },
        methods: {
        }
    }
</script>

<style scoped>

.bg {
    position: absolute;

    /* background: url('../assets/basketball-bg-1.jpg'); */
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    width: 100%;
    height: auto;
    min-height: 100%;
}

.d4 {
    position: relative;
    max-height: 100%;
    overflow: auto;
}
</style>
